import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import instance, { baseUrl } from "../../axios";
import { Button, Card, CardActionArea, CardContent, CardMedia, Grid, Typography } from "@mui/material";
import CopyToClipboard from "react-copy-to-clipboard";
import { Link } from "react-router-dom";
import CustomProgressBar from "../customProgressBar/CustomProgressBar";
// import { useParams } from "react-router-dom";
// import { Link } from "react-router-dom";
// import instance, { baseUrl } from "../../axios";
// import { useNavigate } from "react-router-dom";
// // MUI components
// import CardMedia from "@mui/material/CardMedia";
// import { Button } from "@mui/material";
// import { Card, Grid } from "@mui/material";
// import CardContent from "@mui/material/CardContent";
// // import CardMedia from "@mui/material/CardMedia";
// import Typography from "@mui/material/Typography";
// import { CardActionArea } from "@mui/material";
// import CustomProgressBar from "../customProgressBar/CustomProgressBar";
// import CopyToClipboard from "react-copy-to-clipboard";

export default function MosqueInfo() {
  const { mosqueId } = useParams();
  const [mosqueInfo, setMosqueInfo] = useState({});
  const [mosqueAdsArray, setMosqueAdsArray] = useState([]);
  const [admin, setAdmin] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [copied, setCopied] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    instance
      .get(`api/mosques/${mosqueId}`)
      .then((res) => {
        setMosqueInfo(res?.data?.data?.mosque);
        // setMosqueAdsArray(res?.data?.data?.mosque?.ads);
        setAdmin(res?.data?.data?.mosque?.mosque_admin);
        setLoading(false);
      })
      .catch((err) => !err.response.data.ok && setError(true));
  }, []);
  useEffect(() => {
    instance
      .get(`api/ads?mosque_id=${mosqueId}`)
      .then((res) => {
        // setMosqueInfo(res?.data?.data?.mosque);
        setMosqueAdsArray(res?.data?.data?.ads);
      })
      .catch((err) => !err.response.data.ok && setError(true));
  }, []);

  ////////////////////////////
  function handleProgress(array) {
    let compoletedAmount = 0;
    let onProgressAmount = 0;
    array.forEach((item) => {
      if (item.status === 3) {
        compoletedAmount += item.amount;
      }
      if (item.status === 2) {
        onProgressAmount += item.amount;
      }
    });

    return { compoletedAmount, onProgressAmount };
  }

  function handleAmount(array) {
    let amount = 0;
    array.forEach((item) => {
      if (item.status === 3) {
        amount += item.amount;
      }
    });
    return amount;
  }
  ///////////////////////////////////////////
  const formatPhoneNumber = (number) => {
    if (number) {
      number = `+${number.slice(0, 3)} ${number.slice(3, 5)} ${number.slice(
        5,
        8
      )}-${number.slice(8, 10)}-${number.slice(10, 12)}`;
      return number;
    }
  };

  ///////////////////////////////////////////
  function handleCopy() {
    setCopied(true);

    setTimeout(() => {
      setCopied(false);
    }, 3000);
  }
  ///////////////////////////////////////////
  //////////////////////////////////////////
  if (error) {
    return (
      <div className="container mx-auto p-2">
        <h1 className="text-3xl text-red-600 text-center">Mavjud emas...</h1>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="container mx-auto p-2">
        <h1 className="text-3xl text-gray-400 text-center">yuklanmoqda...</h1>
      </div>
    );
  }

  return (
    <div className="container mx-auto">
      <div
        style={{
          background: "#FFFFFF",
          boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.08)",
        }}>
        <CardMedia
          component="img"
          // height="140"
          image={`${baseUrl}files/${mosqueInfo?.image_src}`}
          alt="green iguana"
          style={{ objectFit: "cover", maxHeight: "210px" }}
        />
        <div className="go-back-btn">
          <Button className="ortga" onClick={() => navigate(-1)}>
            <img
              src="../../images/angle-left-solid.svg"
              alt="icon"
              className="img-back mr-2"
              width={"13"}
              height={"13"}
            />
            Ortga
          </Button>
        </div>
        <div className="p-[20px] pt-[12px]">
          <p
            className="mb-[12px]"
            style={{
              fontFamily: "Roboto",
              fontStyle: "normal",
              fontWeight: "500",
              fontSize: "20px",
              lineHeight: "130%",
              color: "#000000",
            }}>
            {mosqueInfo?.name}
          </p>
          <p
            className="flex"
            style={{
              marginBottom: "8px",
              fontFamily: "Roboto",
              fontStyle: "normal",
              fontWeight: "400",
              fontSize: "16px",
              lineHeight: "120%",
              letterSpacing: "0.15px",
              color: "#1A1A1A",
            }}>
            <img
              src="../../images/icon-location-card.svg"
              alt="location icon"
              className="mr-[5px]"
            />
            {mosqueInfo?.location}
          </p>
          <div className="flex items-center gap-6">
            <a
              href={`https://www.google.com/maps/search/?api=1&query=${mosqueInfo?.latitude},${mosqueInfo?.longitude}`}
              style={{
                padding: "6px 10px",
                fontFamily: "Roboto",
                fontStyle: "normal",
                fontWeight: "500",
                fontSize: "13px",
                lineHeight: "22px",
                letterSpacing: "0.46px",
                textTransform: "uppercase",
                color: "#1976D2",
                background: "rgba(25, 118, 210, 0.1)",
                borderRadius: "4px",
                width: "92px",
                height: "34px",
              }}
              className="flex">
              Harita
              <img
                src="../../images/icon-link.svg"
                alt=""
                width={"13.5"}
                height="13.5"
                className="ml-[10px]"
              />
            </a>

            <CopyToClipboard text={"+" + mosqueInfo?.phone}>
              <p
                // href={`tel:${mosqueInfo?.phone}`}
                style={{
                  position: "relative",
                  padding: "6px 10px",
                  fontFamily: "Roboto",
                  fontStyle: "normal",
                  fontWeight: "500",
                  fontSize: "13px",
                  lineHeight: "22px",
                  letterSpacing: "0.46px",
                  textTransform: "uppercase",
                  color: "#1976D2",
                  background: "rgba(25, 118, 210, 0.1)",
                  borderRadius: "4px",
                  width: "max-content",
                  height: "34px",
                  cursor: "pointer",
                }}
                onClick={handleCopy}>
                Tel: {formatPhoneNumber(mosqueInfo?.phone)}
                {copied ? (
                  <>
                    <strong className="absolute py-2 px-2 rounded-xl top-0 left-44 text-sm font-light text-green-600 border-green-600 border-[1px] min-w-max">
                      Nusxa olindi!
                    </strong>
                  </>
                ) : null}
              </p>
            </CopyToClipboard>
          </div>
        </div>
      </div>
      {/* Announcements */}
      <div className="mt-1 p-[20px] bg-[#FAFAFA]">
        <h3
          className="mb-[16px]"
          style={{
            fontFamily: "Roboto",
            fontStyle: "normal",
            fontWeight: "400",
            fontSize: "20px",
            lineHeight: "133.4%",
            color: "rgba(0, 0, 0, 0.87)",
          }}>
          Masjid e’lonlari ({mosqueAdsArray.length})
        </h3>

        {/* cards */}
        <div>
          <Grid container spacing={2}>
            {mosqueAdsArray.map((item) => (
              <Grid item xs={6} md={6} key={item?.id}>
                <Link to={`/announcement/${item?.id}`} key={item?.id}>
                  <Card sx={{ maxWidth: 345 }}>
                    <CardActionArea>
                      <CardMedia
                        component="img"
                        height={50}
                        image={
                          item?.image_src
                            ? `${baseUrl}files/${item?.image_src}`
                            : "/images/mosque-contruction.jpg"
                        }
                        alt="green iguana"
                        style={{ objectFit: "contain" }}
                      />
                      <CardContent>
                        <Typography
                          sx={{
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                          }}
                          gutterBottom
                          component="div">
                          {item?.name}
                        </Typography>
                        <Typography
                          sx={{
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            display: "flex",
                          }}
                          variant="body2"
                          color="#1976D2">
                          <img
                            src="../../images/icon-location-2.svg"
                            alt=""
                            className="mr-1"
                          />
                          {item?.mosque?.name}
                        </Typography>
                        {/* <ProgressBar
                          completed={
                            item?.totalHelp
                              ? 100 * (item?.totalHelp / item?.amount)
                              : 0
                          }
                          height="10px"
                          margin="2px 0px"
                          isLabelVisible={false}
                          bgColor="#2E7D32"
                        /> */}
                        <CustomProgressBar
                          completed={
                            handleProgress(item.requests).compoletedAmount
                          }
                          inProgress={
                            handleProgress(item.requests).onProgressAmount
                          }
                          total={item?.amount}
                        />
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{ color: "#404040" }}>
                          {item?.totalHelp | 0}/{item?.amount}
                          {` ${item?.amount_type} ${item?.category?.name}`}
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Link>
              </Grid>
            ))}
          </Grid>
        </div>
        {/* end of cards */}
      </div>
    </div>
  );
}
